import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getInfluencer } from "../../redux/actions/UserAction";
import { Card, Row, Col, Affix, Table, Spin, message, Input, Button } from 'antd';
import { CopyToClipboard } from "react-copy-to-clipboard";
import { CopyOutlined } from '@ant-design/icons';


const AffiliateProfile = () => {
    const dispatch = useDispatch();
    let { id } = useParams();
    console.log(id)
    const [affiliateDetails, setAffiliateDetails] = useState([]);
    const [activePage, setActivePage] = useState(1);
    const [influencerDate, setInfluencerData] = useState(null);
    const [loadMore, setLoadMore] = useState(null);

    useEffect(() => {
        influencer(1)
      }, [])

    const influencer =(activePage) => {
        setLoadMore(true);
        const affiliate_data = {
            influencerId: id,

        };
        var params = {
            page:activePage,
            limit:100
          }
        const onSuccess = (data) => {
            setLoadMore(false);
            console.log(data.data);
            setInfluencerData(data.data)
            setAffiliateDetails([...data.data.affiliateData,...affiliateDetails]);
        };
        const onError = (data) => {
            setLoadMore(false);
        };
        dispatch(getInfluencer(affiliate_data,params, onSuccess,onError));
    }

    const onChangePagination = (page, pageSize) =>{
        if(page.current > activePage){
          influencer(page.current)
          setActivePage(page.current)
        }
      }
      const modifiedDate =(date) => {
        const incommingDate = date.split("T")
        return incommingDate[0]
        }

    var data = affiliateDetails?.map((data, i) => ({
        key: i,
        no: i + 1,
        name: data?.learner?.name,
        amount: data?.amount,
        date:  modifiedDate(data?.startDate),
        fee: Math.round(data?.amountWithoutGST * influencerDate?.influencerData?.affiliatefee * 0.01)          
    }))

    const columns = [
        { title: "No", width: 5, dataIndex: "no", key: "1" },
        { title: "Customer Name", width: 5, dataIndex: "name", key: "2" },
        { title: "Subscription Amount", width: 5, dataIndex: "amount", key: "3" },
        { title: "Subscription Date", width: 5, dataIndex: "date", key: "4" },
        { title: "Affiliate Fee", width: 5, dataIndex: "fee", key: "5" },

    ];

    const influencerInfo = influencerDate?.influencerData || {};
    const utmMedium = influencerInfo?._id || influencerInfo?.influencerId || id || "";
    const utmContent = influencerInfo?.cuponDiscount ?? influencerInfo?.couponDiscount ?? "";
    const utmCampaign = influencerInfo?.refferalcode ?? influencerInfo?.referralCode ?? "";
    const utmLink = utmMedium || utmContent || utmCampaign
        ? `https://clapingo.com/index-affiliate?utm_source=affiliate&utm_medium=${utmMedium}&utm_content=${utmContent}&utm_campaign=${utmCampaign}`
        : "";

    useEffect(() => {
        // Log UTM details whenever they are computed/updated
        if (utmLink) {
            console.log("UTM details:", {
                utmLink,
                utm_medium: utmMedium,
                utm_content: utmContent,
                utm_campaign: utmCampaign,
                influencerId: influencerInfo?._id || influencerInfo?.influencerId,
                couponDiscount: influencerInfo?.cuponDiscount ?? influencerInfo?.couponDiscount,
                referralCode: influencerInfo?.refferalcode ?? influencerInfo?.referralCode,
            });
        } else {
            console.log("UTM details pending — missing data", influencerInfo);
        }
    }, [utmLink, utmMedium, utmContent, utmCampaign]);

    return (

        <div className="text-center">
            <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 16 }}>
                <p style={{ margin: 0, fontSize: 14, minWidth: 100, textAlign: "left" }}>Web UTM link:</p>
                <div style={{ display: "flex", gap: 8, alignItems: "center", width: "100%", maxWidth: 800 }}>
                    <Input
                        readOnly
                        value={utmLink}
                        placeholder="UTM link will appear here"
                        style={{ borderRadius: 10 }}
                    />
                    <CopyToClipboard
                        text={utmLink}
                        onCopy={() => {
                            if (utmLink) {
                                message.success("Referral link copied successfully");
                            }
                        }}
                    >
                        <Button type="default" disabled={!utmLink} icon={<CopyOutlined />} />
                    </CopyToClipboard>
                </div>
            </div>
            <div className="site-card-wrapper">
                <Row gutter={16}>
                    <Col span={6}>
                        <Card title="Your Earning" bordered={false}>
                            {influencerDate?.influencerData?.earning}
                        </Card>
                    </Col>
                    <Col span={6}>
                        <Card title="Subscribed User" bordered={false}>
                            {influencerDate?.influencerData?.subscribedUser}
                        </Card>
                    </Col>
                    <Col span={6}>
                        <Card title="Demo Taken" bordered={false}>
                        {influencerDate?.demoBooked}
                        </Card>
                    </Col>
                    <Col span={6}>
                        <Card title="Signup User" bordered={false}>
                        {influencerDate?.signupUser}
                        </Card>
                    </Col>
                </Row>
            </div>
            <div style={{marginTop:"20px"}}>

                {
                    loadMore?
                    <div className="spin-center">
                            <Spin size="large" />
                        </div>
                        :
                        <Table
                
                        columns={columns}
                        dataSource={data}
                        scroll={{ x: 1450 }}
                        onChange={onChangePagination}
                        pagination={{
                            pageSize: 100,
                            total:influencerDate?.influencerData?.subscribedUser,
                            defaultCurrent: activePage
                        }}
        
                    />
                }
  
            </div>

        </div >
    )
}

export default AffiliateProfile;